import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { profile, images } from '../data/profile';
import { PortraitFrame } from '../components/PortraitFrame';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Overview() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-176" data-mp="27kjis7nqln33">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-177" data-mp="2cibjnr6d0jjf">
        <div className="grid items-center gap-16 lg:grid-cols-12 lg:gap-14" data-id="element-178" data-mp="2chrzs4x5fl2r">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: EASE
        }} className="lg:col-span-7" data-id="element-179" data-mp="2hftj8qyhlmer">
            <p className="font-sans text-[11px] font-semibold uppercase tracking-overline text-emerald" data-id="element-180" data-mp="2qh1ipccqotaf">
              Global People Executive · C-Suite Board Advisor
            </p>

            <h1 className="mt-6 font-display text-5xl leading-[1.05] text-navy sm:text-6xl lg:text-[64px]" data-id="element-181" data-mp="w4l6zw16cmy6">
              Samanntha
              <br data-id="element-182" data-mp="2zem91rssr926" />
              DuBridge
            </h1>

            <p className="mt-8 max-w-xl font-sans text-xl leading-snug text-navy-800" data-id="element-183" data-mp="2ul9ktis1549y">
              {profile.title}
            </p>
            <p className="mt-3 max-w-xl font-sans text-sm leading-relaxed text-navy-400" data-id="element-184" data-mp="2qidasggk2ghm">
              {profile.subheader}
            </p>

            <p className="mt-9 max-w-xl font-sans text-[17px] leading-relaxed text-navy-600" data-id="element-185" data-mp="3ic5gws3iqln0">
              {profile.summary}
            </p>

            <div className="mt-8 max-w-xl space-y-5" data-id="element-186" data-mp="3eatq4j8wrud8">
              {profile.bio.map(paragraph => <p key={paragraph} className="font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-187" data-mp="3994hfa95rssb">
                  {paragraph}
                </p>)}
            </div>

            <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-188" data-mp="1xxdbmyyx9b8r">
              <Link to="/inquire" className="group inline-flex items-center justify-center gap-2 bg-emerald px-7 py-4 font-sans text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-emerald-700" data-id="element-189" data-mp="1svxrd94kj8rf">
                Board &amp; Advisory Inquiries
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-190" data-mp="1lcokpnng5o62" />
              </Link>
              <Link to="/pillars" className="inline-flex items-center justify-center gap-2 bg-parchment-deep px-7 py-4 font-sans text-sm font-medium text-navy transition-colors duration-150 ease-out hover:bg-navy hover:text-white" data-id="element-191" data-mp="1bnn1lolluqnv">
                Review Board Pillars
              </Link>
            </div>

            <p className="mt-9 inline-flex items-center gap-2 font-sans text-xs text-navy-400" data-id="element-192" data-mp="16ojwk45mkkfw">
              <MapPinIcon className="h-3.5 w-3.5 text-emerald-500" aria-hidden="true" data-id="element-193" data-mp="sp0y632m8ngs" />
              {profile.location}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          ease: EASE,
          delay: 0.08
        }} className="lg:col-span-5" data-id="element-194" data-mp="e1aijichqxlt">
            <div className="relative bg-brass/10 p-8 sm:p-12 lg:p-10" data-id="element-195" data-mp="o0rmnvc3h3fo">
              <PortraitFrame src={images.portrait} alt="Portrait of Samanntha DuBridge" backdropClass="bg-emerald" className="mx-auto w-full max-w-[320px]" aspectClass="aspect-[4/5]" data-id="element-196" data-mp="j0nd6p9lt8yy" />
              <p className="mt-10 text-center font-display text-[15px] text-emerald" data-id="element-197" data-mp="16q7y3dpbigav">
                Hewlett Packard Enterprise · 2015 — Present
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}